import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_producers/${agro_exporter_id}`
    );
  },
};
